import React, { useMemo } from 'react';
import { getMessage } from 'util/locale';
import { managementZonesTypes } from 'constants/scripts';

import ManagementZonesQuickView from 'manual/ManagementZonesQuickView';
import { useAppSelector } from 'app/hooks';
import { ZonesData } from './types';
import { isMultiLayerZoneGenerationEnabled } from './selectors';

interface ManagementZonesProps {
  hasPreviousPrescriptions?: boolean;
  onSelectManagementZones: (zonesData: ZonesData) => void;
  selectedManagementZonesId: string;
  zones: ZonesData[];
}

const baseString = 'vra-management-zones';

const ManagementZones = ({
  hasPreviousPrescriptions,
  onSelectManagementZones,
  selectedManagementZonesId,
  zones
}: ManagementZonesProps) => {
  const isMultiLayerEnabled = useAppSelector(isMultiLayerZoneGenerationEnabled);

  // limit managment zones selections to below 100 zones
  const filteredZones = useMemo(() => zones.filter((zonesData) => Object.keys(zonesData.zones).length <= 100), [zones]);

  return (
    <ul className={baseString}>
      {filteredZones.map((zonesData) => {
        const { fertilityActivity, id, managementZonesType } = zonesData;
        
        let headerText = '';
        switch (managementZonesType) {
          case managementZonesTypes.FERTILITY:
            headerText = getMessage(
              `title-text__management-zones-quick-view--fertility--${fertilityActivity}`, zonesData
            );
            break;
          case managementZonesTypes.PLANTING:
            headerText = getMessage('title-text__management-zones-quick-view--planting', zonesData);
            break;
          case managementZonesTypes.APPLICATION:
            headerText = getMessage('title-text__management-zones-quick-view--application', zonesData);
            break;
          case managementZonesTypes.IMPORTED_MAPS:
            headerText = zonesData.name;
            break;
          case managementZonesTypes.GENERATE_ZONES:
            headerText = getMessage(
              `title-text__management-zones-quick-view--generate-zones${isMultiLayerEnabled ? '-multi-layer' : ''}`
            );
            break;
          case managementZonesTypes.SSURGO:
          case managementZonesTypes.FIELD_BOUNDARY:
          default:
            headerText = getMessage(`title-text__management-zones-quick-view--${managementZonesType}`);
            break;
        }

        return (
          <li
            key={id}
            className={`${baseString}__zones-quick-view`}
          >
            <ManagementZonesQuickView
              hasPreviousPrescriptions={hasPreviousPrescriptions}
              headerText={headerText}
              onSelectManagementZones={onSelectManagementZones}
              selectedManagementZonesId={selectedManagementZonesId}
              zonesData={zonesData}
            />
          </li>
        );
      })}  
    </ul>
  );
};

export default ManagementZones;
